import styled from 'styled-components';
import colors from '@theme/colors';
import media from '@theme/media';

export const HeaderWrapper = styled.div`
  z-index: 1;
  background: ${colors.PRIMARY};
  padding: 35px 40px 20px 113px;
  height: 140px;
  min-height: 140px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
`;

export const AttendeeHeaderWrapper = styled.div`
  z-index: 1;
  background: ${colors.PRIMARY};
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
  ${media.large} {
    padding: 35px 40px 20px 113px;
  }
`;

export const SubheaderWrapper = styled.div`
  margin-left: 73px;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
`;

export const MainContent = styled.div`
  padding: 0;
  ${media.large} {
    padding: 30px 40px 90px 113px;
  }
`;

export const Footer = styled.div`
  display: none;
  ${media.large} {
    display: block;
    height: 56px;
    min-height: 56px;
    background-color: ${colors.PRIMARY};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 40 0 113px;
  }
`;



// WEBPACK FOOTER //
// ./components/layout/PageTemplate.js